/* ============================================================
   Hero scroll effect — assets/hero-scroll.js
   Sur les 50 premiers vh de scroll :
   - .hn-hero        : padding 20px→0  + border-radius 20px→0
   - .hn-hero__card  : padding-left/right 0→20 + border-radius 20px→0
   ============================================================ */
(function () {
  const hero = document.querySelector('.hn-hero');
  if (!hero) return;

  const card = hero.querySelector('.hn-hero__card');
  if (!card) return;

  const RADIUS_START = 20;
  const SCROLL_RANGE = window.innerHeight * 0.5;

  function getPaddingStart() {
    return window.innerWidth <= 640 ? 12 : 20;
  }

  function lerp(start, end, t) {
    return start + (end - start) * Math.min(Math.max(t, 0), 1);
  }

  function onScroll() {
    const progress     = window.scrollY / SCROLL_RANGE;
    const paddingStart = getPaddingStart();
    const padding      = lerp(paddingStart, 0, progress); // 20 → 0
    const cardPadding  = lerp(0, paddingStart, progress); // 0 → 20
    const radius       = lerp(RADIUS_START,   0, progress); // 20 → 0

    hero.style.padding      = padding + 'px';
    // Hero : haut plat (0), bas arrondi (20→0)
    hero.style.borderRadius = '0 0 ' + radius + 'px ' + radius + 'px';

    card.style.paddingLeft  = cardPadding + 'px';
    card.style.paddingRight = cardPadding + 'px';
    card.style.borderRadius = radius + 'px'; // 20 → 0 aussi
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();